var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"discounts"},_vm._l((_vm.cart.discounts),function(discount){return _c('div',{key:discount,staticClass:"badge badge-pill badge-primary border-0 mr-2"},[_vm._v(" "+_vm._s(discount)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }